import { constants } from 'app-constants'

export const setCars = cars => ({
  type: constants.SET_CARS,
  payload: cars
})

export const unsetData = () => ({
  type: constants.UNSET_DATA
})

let currentData = localStorage.getItem('wabenzyAdminData') || '{}'
const initialState = JSON.parse(currentData)

export const appData = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_CARS:
      // eslint-disable-next-line no-case-declarations
      let updatedCars = {
        ...initialState,
        cars: action.payload
      }
      localStorage.setItem('wabenzyAdminData', JSON.stringify(updatedCars))
      return updatedCars

    case constants.UNSET_DATA:
      localStorage.removeItem('wabenzyAdminData')
      return {}
    default:
      return state
  }
}
